import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <h2 className="footer-title">MotoNurk motomuuseum</h2>
          <address>
            <p className="footer-address">Narva linn, Vestervalli 17a</p>
            <p className="footer-email"><a href="mailto:info@motonurk.ee">info@motonurk.ee</a></p>
            <p className="footer-phone"><a href="tel:+37255959334">+372 55959334</a></p>
          </address>
        </div>

        <div className="footer-map">
          <iframe
            title="MotoNurk motomuuseumi asukoht kaardil"
            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJH11o2943lEYRVjIbbfWH09k&key=AIzaSyDg1tHZj5eeKldD_Ub87Swa7MPxQt4QQpI"
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="map-iframe"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
